import { useAuth } from "~/hooks/useAuth";
import { useWorkspaceSubscription } from "~/hooks/useSubscription";
import { usePrimaryWorkspace, useWorkspaceMembership } from "~/hooks/workspace";

/**
 * Read-only when the user is a viewer seat, or the workspace owner's
 * subscription is inactive (expired / never paid at workspace level).
 */
export function useWorkspaceReadOnly(workspaceId?: string) {
  const { user } = useAuth();
  const workspace = usePrimaryWorkspace();
  const id = workspaceId ?? workspace.data?.id;
  const membership = useWorkspaceMembership(id);
  const subscription = useWorkspaceSubscription(id);

  const isViewer =
    Boolean(workspace.data) &&
    workspace.data?.owner_id !== user?.id &&
    membership.data?.role === "viewer";

  const subscriptionReadOnly =
    !subscription.isLoading && !subscription.hasPaidAccess;

  return {
    readOnly: isViewer || subscriptionReadOnly,
    isViewer,
    subscriptionExpired: subscriptionReadOnly && !isViewer,
    isLoading: membership.isLoading || subscription.isLoading,
  };
}
